import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import { IEscrowFormData } from '../../../types/order/escrow/state/IEscrowFormData';

export const escrowFormDataSlice = createSlice<IEscrowFormData, SliceCaseReducers<IEscrowFormData>>({
  name: 'escrowFormDataSlice',
  initialState: {
    originalDeposits: [],
    currentDeposits: [],
    originalDisbursements: [],
    currentDisbursements: [],
  },
  reducers: {
    setFormData: (state, action: PayloadAction<IEscrowFormData>) => {
      state.originalDeposits = action.payload.originalDeposits;
      state.originalDisbursements = action.payload.originalDisbursements;
      state.currentDeposits = action.payload.currentDeposits;
      state.currentDisbursements = action.payload.currentDisbursements;
    },
  },
});

export const { setFormData } = escrowFormDataSlice.actions;
